import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Accordion } from "react-bootstrap";

import * as currentPageActions from "../../redux/actions/current-page";
import client from "../../axios";
import { UserData } from "../interfaces/common";
import { RootReducer } from '../../redux/reducers'

const Sidebar = () => {
  /* 현재 페이지 항목 들고 옴(색 변경을 위하여 )*/
  const currentPage = useSelector((state: RootReducer) => state.currentPage, shallowEqual)
  let curPg = currentPage.current_page
  /* 디스패치 사용 */
  const dispatch = useDispatch();

  const [user, setUser] = useState<UserData>({
    user_nm: "",
    corp_nm: "",
    admin_gbn: "",
  });

  /* 클릭 시 디스패치 */
  /* 입출고관리 */
  const handleInputBuy = () => dispatch(currentPageActions.inputBuy());
  const handleInputSell = () => dispatch(currentPageActions.inputSell());
  /* 기준정보 */
  const handleUserCom = () => dispatch(currentPageActions.usercom());
  const handleStandardCode = () => dispatch(currentPageActions.standardCode());
  const handleCustomer = () => dispatch(currentPageActions.customer());
  const handleProduct = () => dispatch(currentPageActions.product());
  /* 생산관리 */
  const handleAddRecipe = () => dispatch(currentPageActions.addRecipe());
  const handleProdPerf = () => dispatch(currentPageActions.prodPerf());
  const handleProdDaily = () => dispatch(currentPageActions.prodDaily());
  const handleExcelApply = () => dispatch(currentPageActions.excelApply());
  /* 재고관리 */
  const handleInitialStock = () => dispatch(currentPageActions.initialStock());
  const handleStockStatus = () => dispatch(currentPageActions.stockStatus());
  const handleStockPay = () => dispatch(currentPageActions.stockPay());
  const handleMatPay = () => dispatch(currentPageActions.matPay());
  /* 환경설정 */
  const handleSettings = () => dispatch(currentPageActions.settings());

  const handleTemperature = () => dispatch(currentPageActions.temperature());
  const handleDevices = () => dispatch(currentPageActions.devices());

  /* 입출고관리 메뉴 */
  const inOutManage = [
    { name: "입고(구매) 입력", handleClick: handleInputBuy, val: "input-buy" },
    {
      name: "출고(판매) 입력",
      handleClick: handleInputSell,
      val: "input-sell",
    },
  ];

  /* 기준정보 항목들 */
  const standardInfo = [
    { name: "사용회사 정보 등록", handleClick: handleUserCom, val: "user-com" },
    {
      name: "기준코드 등록",
      handleClick: handleStandardCode,
      val: "standard-code",
    },
    { name: "거래처 등록", handleClick: handleCustomer, val: "customer" },
    { name: "품목 등록 ", handleClick: handleProduct, val: "product" },
    { name: "레시피 등록", handleClick: handleAddRecipe, val: "add-recipe" },
    {
      name: "품목/레시피 엑셀 일괄등록",
      handleClick: handleExcelApply,
      val: "excel-apply",
    },
  ];

  /* 생산관리 항목들 */
  const prodManage = [
    { name: "생산실적 입력", handleClick: handleProdPerf, val: "prod-perf" },
    { name: "생산일보", handleClick: handleProdDaily, val: "prod-daily" },
  ];

  /* 재고관리 항목들 */
  const stockManage = [
    {
      name: "기초재고 등록",
      handleClick: handleInitialStock,
      val: "initial-stock",
    },
    { name: "재고현황", handleClick: handleStockStatus, val: "stock-status" },
    { name: "재고수불부", handleClick: handleStockPay, val: "stock-pay" },
    { name: "원료수불부", handleClick: handleMatPay, val: "mat-pay" },
  ];

  const settings = [
    { name: "환경설정", handleClick: handleSettings, val: "settings" },
  ];

  const temperatures = [
    { name: "온도기록부", handleClick: handleTemperature, val: "temperature" },
    { name: "온도계 목록", handleClick: handleDevices, val: "devices" },
  ];

  useEffect(() => {
    client.get("/api/auth/get-user-profile").then((res) => {
      setUser(res.data);
    });
  }, []);

  return (
    <nav
      id="sidebarMenu"
      className="p-0 d-md-block position-fixed collapse border-end"
      style={{ width: "250px", height: 800, zIndex: 500 }}
    >
      <Accordion
        defaultActiveKey={["0", "1", "2", "3", "4",]}
        alwaysOpen
        className="border-0 col-12 position-sticky"
      >
        {user.admin_gbn !== "3" && (
          <>
            <Accordion.Item eventKey="0" className="rounded-0 border-0 py-1">
              <Accordion.Header>입출고관리</Accordion.Header>
              <Accordion.Body className="d-grid px-0 py-0">
                <div className="btn-group-vertical">
                  {inOutManage.map((content, index) => (
                    <button
                      key={`in_out_manage_${index}`}
                      className="btn border-0 rounded-0 shadow-none sidebar-content-button"
                      onClick={() => {
                        content.handleClick();
                      }}
                    >
                      <div
                        className={`${curPg === content.val ? "bg-gray" : ""
                          } d-inline p-2 rounded-2`}
                      >
                        {content.name}
                      </div>
                    </button>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="rounded-0 border-0 py-1">
              <Accordion.Header>생산관리</Accordion.Header>
              <Accordion.Body className="d-grid gap-2 px-0 py-0">
                <div className="btn-group-vertical">
                  {prodManage.map((content, index) => (
                    <button
                      key={`prod_manage_${index}`}
                      className="btn border-0 rounded-0 shadow-none sidebar-content-button"
                      onClick={() => {
                        content.handleClick();
                      }}
                    >
                      <div
                        className={`${curPg === content.val ? "bg-gray" : ""
                          } d-inline p-2 rounded-2`}
                      >
                        {content.name}
                      </div>
                    </button>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className="rounded-0 border-0 py-1">
              <Accordion.Header>재고관리</Accordion.Header>
              <Accordion.Body className="d-grid gap-2 px-0 py-0">
                <div className="btn-group-vertical">
                  {stockManage.map((content, index) => (
                    <button
                      key={`stock_manage_${index}`}
                      className="btn border-0 rounded-0 shadow-none sidebar-content-button"
                      onClick={() => {
                        content.handleClick();
                      }}
                    >
                      <div
                        className={`${curPg === content.val ? "bg-gray" : ""
                          } d-inline p-2 rounded-2`}
                      >
                        {content.name}
                      </div>
                    </button>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className="rounded-0 border-0 py-1">
              <Accordion.Header>기준정보</Accordion.Header>
              <Accordion.Body className="d-grid px-0 py-0">
                <div className="btn-group-vertical">
                  {standardInfo.map((content, index) => (
                    <button
                      key={`standard_info_${index}`}
                      className="btn border-0 rounded-0 shadow-none sidebar-content-button"
                      onClick={() => {
                        content.handleClick();
                      }}
                    >
                      <div
                        className={`${curPg === content.val ? "bg-gray" : ""
                          } d-inline p-2 rounded-2`}
                      >
                        {content.name}
                      </div>
                    </button>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </>
        )}

        {user.admin_gbn === "3" && (
          <>
            <Accordion.Item
              eventKey="4"
              className="rounded-0 border-0 nostyle py-1"
              onClick={() => {
                temperatures[0].handleClick();
              }}
            >
              <Accordion.Header>
                <div
                  className={`${curPg === temperatures[0].val ? "bg-gray" : ""
                    } d-inline p-2 rounded-2`}
                >
                  {temperatures[0].name}
                </div>
              </Accordion.Header>
            </Accordion.Item>

            <Accordion.Item
              eventKey="5"
              className="rounded-0 border-0 nostyle py-1"
              onClick={() => {
                temperatures[1].handleClick();
              }}
            >
              <Accordion.Header>
                <div
                  className={`${curPg === temperatures[1].val ? "bg-gray" : ""
                    } d-inline p-2 rounded-2`}
                >
                  {temperatures[1].name}
                </div>
              </Accordion.Header>
            </Accordion.Item>
          </>
        )}

        {user.admin_gbn !== "3" && (
          <Accordion.Item
            eventKey="5"
            className="rounded-0 border-0 nostyle py-1"
            onClick={() => {
              settings[0].handleClick();
            }}
          >
            <Accordion.Header>
              <div
                className={`${curPg === settings[0].val ? "bg-gray" : ""
                  } d-inline p-2 rounded-2`}
              >
                {settings[0].name}
              </div>
            </Accordion.Header>
          </Accordion.Item>
        )}
      </Accordion>
    </nav>
  );
};

export default Sidebar;
